module.exports = __webpack_public_path__ + "static/logo-79d19dea6879529e8d8219c2ba339da8.svg";